import { useHistory } from "react-router-dom";

/**
 * This makes going to the previous route easier.
 * Also to make code cleaner and closures easier to write,
 * we export this function as a standalone.
 */
export function useGoBack(): () => void {
  return useHistory().goBack;
}
